import React, { Component } from 'react';
import AuthService from '../../services/api/auth';
import Cookies from 'universal-cookie';
import LoadingModal from '../../components/LoadingModal';
import { withAlert } from 'react-alert';
import Helper from '../../helpers';

const cookies = new Cookies();

class ProcessPayment extends Component {
    constructor(props) {
        super(props);

        this.state = {
            number: '',
            numberCountry: '',
            loading: true,
        };
    }

    componentDidMount() {
        let paymentParams = Helper.getUrlParams();
        AuthService.validatePayment(paymentParams)
            .then(response => {
                if (response.token) {
                    cookies.set('token', response.token, { path: '/' });
                }
                cookies.set('fleetId', response.fleetId);

                if (response.language) {
                    cookies.set('lang', response.language);
                }

                AuthService.loadConfig(response.fleetId, cookies.get('lang')).then(d => {
                    window.SET_VULOG_DATA(d);
                    this.setState({
                        loading: false,
                    });

                    if (response.success) {
                        AuthService.getAccountStatus().then(response => {
                            if (response.next === null) {
                                this.props.history.push('/register/status');
                            } else {
                                this.props.history.push(response.next);
                            }
                        });
                    } else {
                        this.props.history.push('/register/payment-error');
                    }
                });
            })
            .catch(error => {
                alert(window.VULOG_TRANSLATE('Payment data invalid !'));
            });
    }

    render() {
        return (
            <div className="container-fluid wrapper">
                <LoadingModal loading={true} message={'PAYMENT_LOADING_MESSAGE'} />
            </div>
        );
    }
}
export default withAlert(ProcessPayment);
